import { useState, useEffect, useRef } from "react";
import "./ContactForm.css";
import checkIcon from "../../assets/CheckExito/CheckBox.svg";
import contactImage from "./contactImage.png"
const fallbackCountries = [
  "Afganistán",
  "Albania",
  "Alemania",
  "Andorra",
  "Angola",
  "Antigua y Barbuda",
  "Arabia Saudita",
  "Argelia",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaiyán",
  "Bahamas",
  "Bangladés",
  "Barbados",
  "Baréin",
  "Bélgica",
  "Belice",
  "Benín",
  "Bielorrusia",
  "Birmania",
  "Bolivia",
  "Bosnia y Herzegovina",
  "Botsuana",
  "Brasil",
  "Brunéi",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Bután",
  "Cabo Verde",
  "Camboya",
  "Camerún",
  "Canadá",
  "Catar",
  "Chad",
  "Chile",
  "China",
  "Chipre",
  "Colombia",
  "Comoras",
  "Corea del Norte",
  "Corea del Sur",
  "Costa de Marfil",
  "Costa Rica",
  "Croacia",
  "Cuba",
  "Dinamarca",
  "Dominica",
  "Ecuador",
  "Egipto",
  "El Salvador",
  "Emiratos Árabes Unidos",
  "Eritrea",
  "Eslovaquia",
  "Eslovenia",
  "España",
  "Estados Unidos",
  "Estonia",
  "Esuatini",
  "Etiopía",
  "Filipinas",
  "Finlandia",
  "Fiyi",
  "Francia",
  "Gabón",
  "Gambia",
  "Georgia",
  "Ghana",
  "Granada",
  "Grecia",
  "Guatemala",
  "Guyana",
  "Guinea",
  "Guinea-Bisáu",
  "Guinea Ecuatorial",
  "Haití",
  "Honduras",
  "Hungría",
  "India",
  "Indonesia",
  "Irak",
  "Irán",
  "Irlanda",
  "Islandia",
  "Islas Marshall",
  "Islas Salomón",
  "Israel",
  "Italia",
  "Jamaica",
  "Japón",
  "Jordania",
  "Kazajistán",
  "Kenia",
  "Kirguistán",
  "Kiribati",
  "Kuwait",
  "Laos",
  "Lesoto",
  "Letonia",
  "Líbano",
  "Liberia",
  "Libia",
  "Liechtenstein",
  "Lituania",
  "Luxemburgo",
  "Madagascar",
  "Malasia",
  "Malaui",
  "Maldivas",
  "Malí",
  "Malta",
  "Marruecos",
  "Mauricio",
  "Mauritania",
  "México",
  "Micronesia",
  "Moldavia",
  "Mónaco",
  "Mongolia",
  "Montenegro",
  "Mozambique",
  "Namibia",
  "Nauru",
  "Nepal",
  "Nicaragua",
  "Níger",
  "Nigeria",
  "Noruega",
  "Nueva Zelanda",
  "Omán",
  "Países Bajos",
  "Pakistán",
  "Palaos",
  "Palestina",
  "Panamá",
  "Papúa Nueva Guinea",
  "Paraguay",
  "Perú",
  "Polonia",
  "Portugal",
  "Reino Unido",
  "República Centroafricana",
  "República Checa",
  "República del Congo",
  "República Democrática del Congo",
  "República Dominicana",
  "Ruanda",
  "Rumanía",
  "Rusia",
  "Samoa",
  "San Cristóbal y Nieves",
  "San Marino",
  "San Vicente y las Granadinas",
  "Santa Lucía",
  "Santo Tomé y Príncipe",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leona",
  "Singapur",
  "Siria",
  "Somalia",
  "Sri Lanka",
  "Sudáfrica",
  "Sudán",
  "Sudán del Sur",
  "Suecia",
  "Suiza",
  "Surinam",
  "Tailandia",
  "Tanzania",
  "Tayikistán",
  "Timor Oriental",
  "Togo",
  "Tonga",
  "Trinidad y Tobago",
  "Túnez",
  "Turkmenistán",
  "Turquía",
  "Tuvalu",
  "Ucrania",
  "Uganda",
  "Uruguay",
  "Uzbekistán",
  "Vanuatu",
  "Vaticano",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Yibuti",
  "Zambia",
  "Zimbabue",
];

export default function ContactForm({preselectedServiceId = null}) {
  console.log("CONTACT FORM JS preselectedServiceId:", preselectedServiceId)
    const API_BASE_URL = process.env.REACT_APP_API_URL;

  const [cursosList, setCursosList] = useState([]);
  const [serviciosList, setServiciosList] = useState([]);

  const [formData, setFormData] = useState({
    empresa: "", pais: "",nombre: "", apellido: "", correo: "",
    celular: "", curso_id: "", servicio_id: "", consultas: "",});
  
  const [displayCurso, setDisplayCurso] = useState("");
  const [displayServicio, setDisplayServicio] = useState("");
  const [searchPais, setSearchPais] = useState("");

  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [search, setSearch] = useState({ pais: "", curso: "", servicio: "" });
  const [filteredCountries, setFilteredCountries] = useState(fallbackCountries);
  const [showDropdown, setShowDropdown] = useState(null);

  // const dropdownRef = useRef(null);
  // 🔥 2. FETCH PARA LLENAR LAS LISTAS AL CARGAR LA PÁGINA
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/public/get_dropdowns.php`);
        const data = await res.json();
        
        if (data.status === "success") {
          setCursosList(data.cursos);
          setServiciosList(data.servicios);
          console.log("servicios:", data.servicios)
        }
      } catch (error) {
        console.error("Error cargando los dropdowns:", error);
      }
    };

    fetchDropdowns();
  }, []); // Se ejecuta una sola vez al cargar el componente


  // 🔥 3. AUTO-COMPLETAR (Ajustado)
  // Ahora espera a que serviciosList tenga datos antes de intentar buscar el nombre
  useEffect(() => {
    if (preselectedServiceId && serviciosList.length > 0) {
      console.log("ENTRE AL AUTOCOMPLETADO DEL FORMULARIO")
      console.log("serviciosList", serviciosList)
      console.log("preselectedServiceId", preselectedServiceId)


      setFormData(prev => ({ ...prev, servicio_id: preselectedServiceId }));
      
      const servicioEncontrado = serviciosList.find(s => s.id === preselectedServiceId);
      console.log("servicioEncontrado:", servicioEncontrado)
      if (servicioEncontrado) {
        setDisplayServicio(servicioEncontrado.nombre);
      }
    }
  }, [preselectedServiceId, serviciosList]); // <-- Se ejecuta si cambia el ID o si termina de cargar la BD

  // 🔹 Filtrado de países
  useEffect(() => {
    setFilteredCountries(
      fallbackCountries.filter((c) =>
        c.toLowerCase().includes(search.pais.toLowerCase())
      )
    );
  }, [search.pais]);
// 🔹 Cerrar dropdown al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (e) => {
      // Si el clic NO ocurrió dentro de un elemento con la clase "dropdown", lo cerramos
      if (!e.target.closest('.dropdown')) {
        setShowDropdown(null);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  // 🔹 Cambio genérico
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  // 🔹 Validación
  const validate = () => {
    let newErrors = {};
    if (!formData.nombre.trim()) newErrors.nombre = "Requerido";
    if (!formData.apellido.trim()) newErrors.apellido = "Requerido";
    if (!formData.correo.trim()) {
      newErrors.correo = "Requerido";
    } else if (!/\S+@\S+\.\S+/.test(formData.correo)) {
      newErrors.correo = "Correo inválido";
    }
    return newErrors;
  };

const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(
       `${API_BASE_URL}/contact/save.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData), // Enviamos el JSON limpio con los IDs
        }
      );

      const result = await res.json();
      
      if (result.status === "success") {
        setShowSuccess(true);
        // Limpiar el formulario
        setFormData({ empresa: "", pais: "", nombre: "", apellido: "", correo: "", celular: "", curso_id: "", servicio_id: "", consultas: "" });
        setDisplayCurso("");
        setDisplayServicio("");
        setSearchPais("");
      } else {
        alert("Hubo un problema al enviar: " + result.message);
      }
    } catch (err) {
      console.error("Error enviando datos:", err);
      alert("Error al conectar con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="contact-section section-white" id="contact">
        <div className="container">
          <div className="container-contact">
            <form className="formulario" onSubmit={handleSubmit}>
              
              {/* === FILA 1 === */}
              <div className="fila">
                <div className="campo">
                  <label>Empresa</label>
                  <input name="empresa" value={formData.empresa} onChange={handleChange} />
                </div>
                <div className="campo">
                  <label>País</label>
                  <div className="dropdown">
                    <input
                      type="text"
                      value={formData.pais || searchPais}
                      onChange={(e) => {
                        setSearchPais(e.target.value);
                        setFormData({ ...formData, pais: "" });
                        setShowDropdown("pais");
                      }}
                      onFocus={() => setShowDropdown("pais")}
                      placeholder="Seleccione un país"
                    />
                    {showDropdown === "pais" && (
                      <ul className="dropdown-list">
                        {filteredCountries.length > 0 ? (
                          filteredCountries.map((country) => (
                            <li
                              key={country}
                              onClick={() => {
                                setFormData({ ...formData, pais: country });
                                setSearchPais("");
                                setShowDropdown(null);
                              }}
                            >
                              {country}
                            </li>
                          ))
                        ) : (
                          <li className="no-results">No encontrado</li>
                        )}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              {/* === FILA 2 === */}
              <div className="fila">
                <div className="campo">
                  <label>Nombre</label>
                  <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} className={errors.nombre ? "input-error" : ""} />
                  {errors.nombre && <span className="error-text">{errors.nombre}</span>}
                </div>
                <div className="campo">
                  <label>Apellido</label>
                  <input type="text" name="apellido" value={formData.apellido} onChange={handleChange} className={errors.apellido ? "input-error" : ""} />
                  {errors.apellido && <span className="error-text">{errors.apellido}</span>}
                </div>
              </div>

              {/* === FILA 3 === */}
              <div className="fila">
                <div className="campo">
                  <label>Correo</label>
                  <input type="email" name="correo" value={formData.correo} onChange={handleChange} className={errors.correo ? "input-error" : ""} />
                  {errors.correo && <span className="error-text">{errors.correo}</span>}
                </div>
                <div className="campo">
                  <label>Celular</label>
                  <input type="tel" name="celular" value={formData.celular} onChange={handleChange} />
                </div>
              </div>

              {/* === FILA 4: CURSOS Y SERVICIOS === */}
              <div className="fila">
                
                {/* 🔹 SELECTOR DE CURSO */}
                <div className="campo">
                  <label>Curso</label>
                  <div className="dropdown">
                    <input
                      type="text"
                      value={displayCurso}
                      onChange={(e) => {
                        setDisplayCurso(e.target.value);
                        setFormData({ ...formData, curso_id: "" }); // Borra el ID si edita el texto
                        setShowDropdown("curso");
                      }}
                      onFocus={() => setShowDropdown("curso")}
                      placeholder="Seleccione un curso"
                    />
                    {showDropdown === "curso" && (
                      <ul className="dropdown-list">
                        {cursosList
                          .filter((c) => c.nombre.toLowerCase().includes(displayCurso.toLowerCase()))
                          .map((c) => (
                            <li
                              key={c.id}
                              onClick={() => {
                                setFormData({ ...formData, curso_id: c.id }); // Guardamos ID
                                setDisplayCurso(c.nombre); // Mostramos texto
                                setShowDropdown(null);
                              }}
                            >
                              {c.nombre}
                            </li>
                          ))}
                      </ul>
                    )}
                  </div>
                </div> 

                {/* 🔹 SELECTOR DE SERVICIO */}
                <div className="campo">
                  <label>Servicio</label>
                  <div className="dropdown">
                    <input
                      type="text"
                      value={displayServicio}
                      onChange={(e) => {
                        setDisplayServicio(e.target.value);
                        setFormData({ ...formData, servicio_id: "" }); // Borra el ID si edita el texto
                        setShowDropdown("servicio");
                      }}
                      onFocus={() => setShowDropdown("servicio")}
                      placeholder="Seleccione un servicio"
                    />
                    {showDropdown === "servicio" && (
                      <ul className="dropdown-list">
                        {serviciosList
                          .filter((s) => s.nombre.toLowerCase().includes(displayServicio.toLowerCase()))
                          .map((s) => (
                            <li
                              key={s.id}
                              onClick={() => {
                                setFormData({ ...formData, servicio_id: s.id }); // Guardamos ID
                                setDisplayServicio(s.nombre); // Mostramos texto
                                setShowDropdown(null);
                              }}
                            >
                              {s.nombre}
                            </li>
                          ))}
                      </ul>
                    )}
                  </div>
                </div>

              </div>

              {/* === Consultas === */}
              <div className="campo">
                <label>Consultas</label>
                <textarea name="consultas" value={formData.consultas} onChange={handleChange}></textarea>
              </div>

              <button type="submit" className="btn-submit">
                {loading ? "Enviando..." : "Contactar"}
              </button>
            </form>

            <div className="imagen-contacto">
              <img src={contactImage} alt="ImagenFormulario" className="svg-item" />
            </div>
                  
          </div>

          {/* 🔹 Modal de éxito */}
          {showSuccess && (
            <div className="modal-overlay">
              <div className="modal-box">
                <img src={checkIcon} alt="check" className="check-icon" />
                <p><strong>TE CONTACTAREMOS A LA BREVEDAD</strong></p>
                <button className="btn-aceptar" onClick={() => setShowSuccess(false)}>
                  Aceptar
                </button>
              </div>
            </div>
          )}

          {/* 🔹 Spinner de carga */}
          {loading && (
            <div className="modal-overlay">
              <div className="loading-dots">
                <span></span><span></span><span></span>
              </div>
            </div>
          )}

        </div>
      </section>
    </>
  );
}